export default __webpack_public_path__ + "static/media/Bed, Green.fd9389c6.png";